import { createContext, useState } from "react";

export const UserContext = createContext([
  { user: null, loading: false, error: null },
  () => {},
]);

export default function UserContextProvider({ children }) {
  const [user, setUser] = useState({ user: null, loading: false, error: null });
  return <UserContext.Provider value={[user, setUser]}>{children}</UserContext.Provider>;
}
